import { useState, useEffect } from 'react';
import { RefreshCw, Loader2, Eye, EyeOff } from 'lucide-react';

const API = process.env.REACT_APP_BACKEND_URL;

const NewsTab = ({ headers }) => {
  const [articles, setArticles] = useState([]);
  const [loading, setLoading] = useState(true);
  const [scanning, setScanning] = useState(false);

  const fetchNews = async () => {
    try {
      const res = await fetch(`${API}/api/admin/news`, { headers, credentials: 'include' });
      if (res.ok) { const data = await res.json(); setArticles(data.articles || []); }
    } catch (e) { console.error('Failed to fetch news:', e); }
    finally { setLoading(false); }
  };

  // eslint-disable-next-line react-hooks/exhaustive-deps -- fetch on mount only


  // eslint-disable-next-line react-hooks/exhaustive-deps -- fetch on mount only
  useEffect(() => { fetchNews(); }, []);

  const triggerScan = async () => {
    setScanning(true);
    try {
      await fetch(`${API}/api/admin/news/scan`, { method: 'POST', headers, credentials: 'include' });
      await fetchNews();
    } catch (e) { console.error('Failed to trigger news scan:', e); }
    finally { setScanning(false); }
  };

  const togglePublish = async (hash, published) => {
    await fetch(`${API}/api/admin/news/${hash}`, {
      method: 'PUT', headers, credentials: 'include', body: JSON.stringify({ published: !published }),
    });
    setArticles(a => a.map(x => x.hash === hash ? { ...x, published: !published } : x));
  };

  if (loading) return <Loader2 className="w-6 h-6 animate-spin text-taxera-blue" />;

  return (
    <div data-testid="admin-news">
      <div className="flex items-center gap-3 mb-4">
        <button
          onClick={triggerScan}
          disabled={scanning}
          className="inline-flex items-center gap-2 px-4 py-2 bg-taxera-teal text-white rounded-full text-sm font-semibold hover:shadow-lg transition-all disabled:opacity-50"
          data-testid="admin-trigger-scan"
        >
          <RefreshCw className={`w-3.5 h-3.5 ${scanning ? 'animate-spin' : ''}`} />
          {scanning ? 'Scanning...' : 'Trigger Scan'}
        </button>
        <span className="text-xs text-slate-400">{articles.length} articles total</span>
      </div>
      <div className="space-y-2">
        {articles.map((a) => (
          <div key={a.hash} className="bg-white rounded-xl border border-slate-200 p-4 flex items-center justify-between gap-4">
            <div className="flex-1 min-w-0">
              <div className="text-sm font-semibold text-taxera-charcoal truncate">{a.title}</div>
              <div className="flex items-center gap-2 mt-1">
                <span className="text-2xs text-slate-400">{a.source_name}</span>
                {a.countries?.slice(0, 3).map(c => <span key={c} className="text-2xs px-1.5 py-0.5 bg-blue-50 text-blue-600 rounded-full">{c}</span>)}
              </div>
            </div>
            <button
              onClick={() => togglePublish(a.hash, a.published)}
              className={`shrink-0 p-2 rounded-lg transition-colors ${a.published ? 'bg-emerald-50 text-emerald-600 hover:bg-emerald-100' : 'bg-slate-100 text-slate-400 hover:bg-slate-200'}`}
              data-testid={`admin-toggle-${a.hash}`}
            >
              {a.published ? <Eye className="w-4 h-4" /> : <EyeOff className="w-4 h-4" />}
            </button>
          </div>
        ))}
      </div>
    </div>
  );
};

export default NewsTab;
